<template>
  <div>
    <v-alert class="alert-info" type="success" :value="show_alert">{{ $t('career.copySuccessMessage') }}</v-alert>
    <popup :message="errMessage" v-if="isErr" @close="isErr = false" />
    <div class="banner">
      <img src="/img/bootcamp/main2.png" class="img-banner" />
      <div class="body-banner">
        <h2 class="title-banner">{{ $t('career.heroTitle') }}</h2>
        <p class="sub-title-banner">{{ $t('career.heroSubtitle') }}</p>
        <button class="button-daftar" style="background-color: #ffde59; color: #36373f" @click="scrollToId('Karir')">
          {{ $t('career.ctaButton1') }}
        </button>
        <button class="button-daftar" @click="sendToWa" style="background-color: #ffffff; color: #162ca2">
          {{ $t('career.ctaButton2') }}
        </button>
      </div>
    </div>
    <div class="ctn-career-about">
      <h3 class="sub-title-about">
        {{ $t('career.uspTitle') }}
      </h3>
      <div class="ctn-content-card">
        <div v-for="(n, idx) in usps" :key="idx" class="content-card">
          <div class="left-span">
            <img :src="n.img" width="48" height="48" style="border-radius: 50%" />
          </div>
          <div>
            <div class="title-2" style="text-align: left">
              {{ n.name }}
            </div>
            <div class="desc" style="text-align: left">
              {{ n.description }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-coll">
      <div class="collaboratif">
        <h1>{{ $t('career.stepsTitle') }}</h1>
        <div class="divider-container">
          <div class="divider-line-container">
            <div class="divider-line"></div>
            <div class="divider-line"></div>
            <div class="divider-line"></div>
            <div class="divider-line"></div>
            <div class="divider-line"></div>
            <div class="divider-line"></div>
            <div class="divider-line"></div>
          </div>
          <div class="divider-circle">
            <div class="inner-circle"></div>
          </div>
          <div class="divider-line-container">
            <div class="divider-line"></div>
            <div class="divider-line"></div>
            <div class="divider-line"></div>
            <div class="divider-line"></div>
            <div class="divider-line"></div>
            <div class="divider-line"></div>
            <div class="divider-line"></div>
          </div>
        </div>
        <div class="desc">
          <div class="card-content" v-for="(data, index) in steps" :key="index">
            <div class="card-img">
              <img :src="data.image_url" alt="" width="100" height="100" style="
                  border-radius: 10px;
                  position: absolute;
                  top: 0;
                  margin-top: -45px;
                  margin-left: 15px;
                  z-index: 0;
                " />
            </div>
            <div class="desc">
              <h3>{{ data.title }}</h3>
              <p>{{ data.description }}</p>
            </div>
          </div>
        </div>
      </div>
      <h1 id="Karir" class="pt-10 text-center" style="font-size: 20px;">
        {{ $t('career.jobOpportunitiesTitle') }}
      </h1>
      <div class="content">
        <v-row>
          <v-col cols="12">
            <div class="action-head">
              <div class="f-search">
                <div class="f-search-ic">
                  <img src="/img/icons/search.png" alt="Search Ic" />
                </div>
                <div style="width: 90%">
                  <v-text-field v-model="filter.position" type="text" class="f-input"
                    :placeholder="$t('career.searchPlaceholder')" dense flat solo></v-text-field>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12">
            <v-select outlined color="#ACAFBF" :placeholder="$t('career.workTypePlaceholder')"
              v-model="filter.work_type" :items="workTypeList" :item-text="'name'" :item-value="'value'"
              style="border-radius: 10px !important; background-color: white" hide-details />
          </v-col>
          <v-col cols="12">
            <v-select outlined color="#ACAFBF" :placeholder="$t('career.levelPlaceholder')" v-model="filter.level"
              :items="levelList" :item-text="'name'" :item-value="'value'"
              style="border-radius: 10px !important; background-color: white" hide-details />
          </v-col>
          <v-col cols="12">
            <Button :name="$t('career.searchButton')" width="100%" height="45px" @click="searchCareer" />
          </v-col>
        </v-row>
        <div class="list-career">
          <div class="list-career-ctn" v-for="(data, idx) in listCareer" :key="idx"
            @click="goToCareerDetail(data.slug_name, data.name)">
            <img :src="data.logo ? data.logo : '/img/career/logo_sample.png'" />
            <h2 class="mb-6 mt-6">{{ data.name }}</h2>
            <p style="font-weight: 500">{{ data.company }}</p>
            <p style="font-weight: 400">{{ data.location }}</p>
            <div class="career-data">
              <div class="label">
                <div style="background-color: #f1f6ff" v-if="data.contract_type">
                  <clock-ic width="18px" height="18px" />
                  <p>{{ data.contract_type }}</p>
                </div>
                <div style="background-color: #faeceb" v-if="data.work_type">
                  <location-ic width="18px" height="18px" />
                  <p>{{ data.work_type }}</p>
                </div>
                <div style="background-color: #faf6e7" v-if="data.level">
                  <level-ic width="18px" height="18px" />
                  <p>{{ data.level }}</p>
                </div>
              </div>
            </div>
            <div class="btn-daftar mt-8">
              <div class="btn-daftar-act">
                <Button :name="$t('career.applyNowButton')" width="100%" @click="() => toCheckout(data)" />
              </div>
              <div class="btn-daftar-cpy">
                <div class="button-outline" @click.stop="() => onCopy(data.slug_name)">
                  <CopyIc width="25px" height="25px" />
                </div>
              </div>
            </div>
            <p class="text-center mt-8">
              {{ $t('career.batasAt') }}
              <b style="font-family: 'Poppins'">{{ moment(data.closed_at) }}</b>
            </p>
          </div>
        </div>
        <Button v-if="total > currentPage" style="margin-top: 32px" :name="$t('loadMore')" width="100%" @click="loadMore" />
        <EmptyData v-if="!listCareer || !listCareer.length" :message="$t('career.noJobsMessage')" />
      </div>
    </div>
    <div class="faqbg">
      <div class="faq">
        <h1>{{ $t('career.faqTitle') }}</h1>
        <AccordeonFaq v-for="(item, index) in questions" :key="index" :title="item.title"
          :description="item.description" :active="item.active" @toggle="toggleAccordion(index, item.title)" />
        <div class="btn-stoke-blue cursor-pointer" @click="goToFaq"
          style="background-color: white; margin-top: 30px;">
          <span class="font-poppins">{{ $t('career.seeAllButton') }}</span>
          <ArrowLong />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "../../../others/Button.vue";
import CopyIc from "@/assets/icons/career/Copy.vue";
import EmptyData from "../../../others/EmptyData.vue";
import ClockIc from "@/assets/icons/career/Clock.vue";
import LevelIc from "@/assets/icons/career/Level.vue";
import LocationIc from "@/assets/icons/career/Location.vue";
import moment from "moment";
import ArrowLong from "@/assets/icons/ArrowLong.vue";
import Popup from "@/components/others/Popup.vue";
import AccordeonFaq from "@/components/AccordeonFaq.vue";

export default {
  name: "MobileCareer",
  components: {
    Button,
    AccordeonFaq,
    ArrowLong,
    ClockIc,
    LevelIc,
    LocationIc,
    CopyIc,
    EmptyData,
    Popup,
  },
  data() {
    return {
      workTypeList: [
        {
          name: "Full-Time",
          value: "Full-Time",
        },
        {
          name: "Part-Time",
          value: "Part-Time",
        },
        {
          name: "Freelance",
          value: "Freelance",
        },
        {
          name: "Internship",
          value: "Internship",
        },
      ],
      levelList: [
        {
          name: "Head",
          value: "Head",
        },
        {
          name: "Senior",
          value: "Senior",
        },
        {
          name: "Middle",
          value: "Middle",
        },
        {
          name: "Junior",
          value: "Junior",
        },
      ],
      filter: {
        position: "",
        work_type: "",
        level: "",
      },
      errMessage: "",
      show_alert: false,
      isErr: false,
      currentPage: 1,
      total: 1,
      questions: [],
      testimonies: [],
      listCareer: [],
    };
  },
  computed: {
    usps() {
      return [
        {
          img: "/img/about/c2.png",
          name: this.$t('career.uspItems.0.name'),
          description: this.$t('career.uspItems.0.description'),
        },
        {
          img: "/img/about/b6.png",
          name: this.$t('career.uspItems.1.name'),
          description: this.$t('career.uspItems.1.description'),
        },
        {
          img: "/img/about/b4.png",
          name: this.$t('career.uspItems.2.name'),
          description: this.$t('career.uspItems.2.description'),
        },
      ];
    },
    steps() {
      return [
        {
          image_url: "/img/corporate/tech/bn1.png",
          title: this.$t('career.steps.0.title'),
          description: this.$t('career.steps.0.description'),
        },
        {
          image_url: "/img/corporate/tech/bn2.png",
          title: this.$t('career.steps.1.title'),
          description: this.$t('career.steps.1.description'),
        },
        {
          image_url: "/img/corporate/tech/bn3.png",
          title: this.$t('career.steps.2.title'),
          description: this.$t('career.steps.2.description'),
        },
        {
          image_url: "/img/corporate/tech/bn4.png",
          title: this.$t('career.steps.3.title'),
          description: this.$t('career.steps.3.description'),
        },
        {
          image_url: "/img/corporate/tech/bn5.png",
          title: this.$t('career.steps.4.title'),
          description: this.$t('career.steps.4.description'),
        },
        {
          image_url: "/img/corporate/tech/bn5.png",
          title: this.$t('career.steps.5.title'),
          description: this.$t('career.steps.5.description'),
        },
      ];
    },
  },
  watch: {
    show_alert() {
      if (!this.show_alert) return;
      setTimeout(() => {
        this.show_alert = false;
      }, 3000);
    },
    "$i18n.locale"() {
      this.getTestimoni();
      this.getCareer();
      this.getFaq();
    },
  },
  methods: {
    sendToWa() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Free Consultation - Mobile Career Page',
        value: 1,
      });
      window.open(
        "https://api.whatsapp.com/send/?phone=6285110563798&text=Hi%20Kak%20HiColleagues,%20saya%20mau%20bertanya",
        "_blank"
      );
    },
    scrollToId(id) {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'View Job Opportunities - Mobile Hero Section',
        value: 1,
      });
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
    scrollRightStep() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Scroll Right - Steps',
        value: 1,
      });
      const container = this.$el.querySelector(".desc");
      const cardWidth = this.$el.querySelector(".card-content").offsetWidth;
      container.scrollLeft += cardWidth * 1.07;
      if (this.indicator < 2) {
        this.indicator++;
        if (this.indicator2 < 1) {
          this.indicator2++;
        }
      }
      if (this.indicator === 2 && this.indicator3 < 1) {
        this.indicator3++;
      }
    },
    scrollLeftStep() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Scroll Left - Steps',
        value: 1,
      });
      const container = this.$el.querySelector(".desc");
      const cardWidth = this.$el.querySelector(".card-content").offsetWidth;
      container.scrollLeft -= cardWidth * 1.07;
      if (this.indicator === 1) {
        this.indicator2--;
      }
      if (this.indicator > 0) {
        this.indicator--;
      }
      if (this.indicator3 < 2 && this.indicator > 0) {
        this.indicator3--;
      }
    },
    moment(date) {
      return moment(date).format("DD MMMM YYYY");
    },
    toCheckout(data) {
      if (new Date() > new Date(data.closed_at)) return;
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: `Apply Now - ${data.name}`,
        value: 1,
      });
      this.$router.push(`/career/applicant/${data.slug_name}`);
    },
    onCopy(id) {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Copy URL - Mobile Career',
        value: 1,
      });
      const clipboardData =
        event.clipboardData ||
        window.clipboardData ||
        event.originalEvent?.clipboardData ||
        navigator.clipboard;
      clipboardData.writeText(`${window.location.href}${id}`);
      this.show_alert = true;
    },
    toggleAccordion(index, title) {
      this.$gtag.event('click', {
        event_category: 'FAQ',
        event_label: `Open FAQ - ${title}`,
        value: 1,
      });
      this.questions[index].active = !this.questions[index].active;
    },
    async getFaq() {
      this.questions = [];
      try {
        const resp = await this.$http.get(`/v1/faq?category=CAREER&is_main=true`);
        this.questions = resp.data.data.faq.map((item) => ({
          description: item.answer[0],
          title: item.question,
          active: false,
        }));
      } catch (err) {
        this.isErr = true;
        this.errMessage = err.response.data.data;
      }
    },
    async getTestimoni() {
      try {
        const resp = await this.$http.get(`/v1/testimony?category=CAREER&is_active=true&page=1&per_page=4`);
        this.testimonies = resp.data.data.testimonies;
      } catch (err) {
        this.isErr = true;
        this.errMessage = err.response.data.data;
      }
    },
    async getCareer() {
      try {
        const res = await this.$http.get(
          `/v1/career?position=${this.filter.position}&level=${this.filter.level}&work_type=${this.filter.work_type}&page=${this.currentPage}&per_page=9`
        );
        this.listCareer = res.data.data.careers;
        this.total = Math.floor(res.data.data.total / 9) + 1;
      } catch (err) {
        this.isErr = true;
        this.errMessage = err.response.data.data;
      }
    },
    searchCareer() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Search Careers - Mobile',
        value: 1,
      });
      this.currentPage = 1;
      this.getCareer();
    },
    loadMore() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: `Load More - Page ${this.currentPage + 1}`,
        value: 1,
      });
      this.currentPage++;
      this.getCareer();
    },
    goToCareerDetail(slug, name) {
      this.$gtag.event('click', {
        event_category: 'Career',
        event_label: `View Career - ${name}`,
        value: 1,
      });
      this.$router.push(`/career/${slug}`);
    },
    goToFaq() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'View More FAQs - Mobile',
        value: 1,
      });
      this.$router.push('/faq');
    },
  },
  mounted() {
    this.getFaq();
    this.getTestimoni();
    this.getCareer();
  },
};
</script>

<style src="./career.css" scoped></style>
